import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { DataTable, DataTableLegend } from '@/models/data-table.model';

class LabelsService extends BaseService {
  private url: string = '/api/data-table';

  constructor() {
    super();
  }

  public async create(
    dataTable: Partial<DataTable>,
  ): Promise<DataResponse<DataTable>> {
    const res = await this.$http.post<DataTable>(this.url, {
      ...dataTable,
      data: JSON.parse(dataTable.data || '{}'),
    });

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(dataTable: DataTable): Promise<DataResponse<DataTable>> {
    const res = await this.$http.put<DataTable>(`${this.url}/${dataTable.id}`, {
      ...dataTable,
      data: JSON.parse(dataTable.data),
    });

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<DataTable[]>> {
    const res = await this.$http.get<DataTable[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getDefaults(): Promise<DataResponse<DataTable[]>> {
    const res = await this.$http.get<DataTable[]>(`${this.url}/defaults`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getLegends(): Promise<DataResponse<DataTableLegend[]>> {
    const res = await this.$http.get<DataTableLegend[]>(`${this.url}/legends`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new LabelsService();
